import { Component, EventEmitter, Input, Output } from '@angular/core';
import { GlobalUtilityService } from '@AppCore/services/global-utility.service';
import { ShoppingService } from '../../shopping.service';
import { CartSummary } from '@AppRoot/shared/models/common.interface';
import { SharedService } from '@AppRoot/shared/services/shared.service';

@Component({
  selector: 'app-order-summary',
  templateUrl: './order-summary.component.html',
  styleUrls: ['./order-summary.component.scss'],
})
export class OrderSummaryComponent {
  cartSummary!: CartSummary;
  paymentMode: string = 'P';
  buttonText: string = 'Place Order';
  @Output() paymentSummary = new EventEmitter<{
    cartSummary: CartSummary;
    buttonText: string;
    paymentMode: string;
  }>();

  constructor(
    private _globalUtilityService: GlobalUtilityService,
    private _shoppingService: ShoppingService,
    private _sharedService: SharedService
  ) {
    this.getCartSummary();
  }

  ngOnInit(): void {
    this._sharedService.cartUpdated.subscribe((data) => {
      this.getCartSummary();
    });
  }

  getCartSummary() {
    this._shoppingService.getCartSummary(this.paymentMode).subscribe({
      next: (data: any) => {
        this.cartSummary = data.data;
        this.paymentSummary.emit({
          cartSummary: data.data,
          buttonText:
            this.paymentMode == 'P'
              ? `Pay Securely ₹${this.cartSummary.total}`
              : 'Place Order',
          paymentMode: this.paymentMode,
        });
      },
      error: (error: any) => {
        this._globalUtilityService.hideLoader();
        this._globalUtilityService.showToast('Error', error.message);
      },
    });
  }

  changePaymentMode(paymentMode: string) {
    this.paymentMode = paymentMode;

    console.log('Payment Mode Changed:', paymentMode);
    if (paymentMode == 'C') {
      this.buttonText = 'Place Order';
    }

    if (paymentMode == 'P') {
      this.buttonText = `Pay Securely ₹${this.cartSummary.total}`;
    }

    this.getCartSummary();
  }
}
